import {
  EvaluationEvaluatorStats,
  EvaluationLog,
  EvaluationStatsResponse,
  EvaluationRun,
} from "@/services/evaluationReports.service";
import { getFileFromLog } from "@/types/app/log";
import { getHue, Hue } from "@components/library/utils/color";
import { randomFromString } from "@components/library/utils/random";
import { LchColor } from "colord";

export const getHueFromRun = (run: EvaluationRun): Hue<LchColor> => {
  const key = run.id;
  const hueSeed = randomFromString(key) * 360;
  return getHue(hueSeed);
};

export const findStatsForRun = (run: EvaluationRun, runStats: EvaluationStatsResponse["run_stats"]) => {
  return runStats.find((v) => v.run_id === run.id);
};

export const findStatsForRunAndEvaluator = <T extends EvaluationEvaluatorStats>(
  run: EvaluationRun,
  evaluatorVersionId: string,
  runsStats: EvaluationStatsResponse["run_stats"],
): T | undefined => {
  const runStats = findStatsForRun(run, runsStats);
  if (!runStats) {
    return undefined;
  }

  const evaluatorStats = runStats.evaluator_stats.find(
    (evaluatorStats) => evaluatorStats.evaluator_version_id === evaluatorVersionId,
  );
  return evaluatorStats as T | undefined;
};
